import { useMemo, useState, useEffect, ChangeEvent } from 'react';

export const useEditingMemoInput = (
  incomingMemo: number | undefined,
  onBlur?: (newMemo: number | undefined) => void,
) => {
  // Format incoming memo to string with two decimal places
  const incomingMemoValue = useMemo(() => {
    return incomingMemo ? incomingMemo.toFixed(2) : '';
  }, [incomingMemo]);

  // Editing state to be used for text input
  const [editingMemoValue, setEditingMemoValue] = useState(incomingMemoValue);

  // Reset editing state whenever incomingDuration changes
  useEffect(() => {
    setEditingMemoValue(incomingMemoValue);
  }, [incomingMemoValue]);

  // Update editing state
  const handleEditingMemoValueChange = (event: ChangeEvent<HTMLInputElement>) => {
    setEditingMemoValue(event.target.value);
  };

  // Convert user input state to formatted time and pass to onBlur callback function
  const handleEditingMemoBlur = () => {
    if (!editingMemoValue) {
      return onBlur?.(undefined);
    }

    const convertedMemo = +editingMemoValue ? +(+editingMemoValue).toFixed(2) : undefined;

    if (!convertedMemo) {
      return setEditingMemoValue(incomingMemoValue);
    }

    // Trigger state change if new value is the same as previous value (needed to trigger formatting useMemo)
    if (convertedMemo === incomingMemo) {
      return setEditingMemoValue(incomingMemoValue);
    }
    onBlur?.(+convertedMemo);
  };

  return {
    value: editingMemoValue,
    onInputChange: handleEditingMemoValueChange,
    onInputBlur: handleEditingMemoBlur,
  };
};
